/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LEADERBOARDS_TITLE = (
    <FormattedMessage
        id='leaderboards.title'
        defaultMessage='Достижения в событии'
    />
)

export const LEADERBOARDS_INFO = (
    <FormattedMessage
        id='wgcwx_leaderboards.info'
        defaultMessage='В течение события игроки и кланы зарабатывают Очки славы, количество которых определяет позицию в рейтингах и награду.{newLine}Рейтинги обновляются каждый час при пересчёте хода на Глобальной карте.'
        values={{
            newLine: <span>&nbsp;</span>,
        }}
    />
)

export const GO_TO_GLOBAL_MAP_RATINGS = (
    <FormattedMessage
        id='leaderboards.go_to_global_map_ratings'
        defaultMessage='К рейтингам на Глобальной карте'
    />
)

export const GO_TO_GLOBAL_MAP_REWARDS = (
    <FormattedMessage
        id='leaderboards.go_to_global_map_rewards'
        defaultMessage='Подробнее о начислении наград'
    />
)

export const LEADERBOARDS_AFFIRMATIVE = (
    <FormattedMessage
        id='leaderboards.affirmative'
        defaultMessage='Так точно!'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/translations.jsx